import * as React from "react";

import { cn } from "@/lib/utils";

type NativeSelectionProps = Omit<
  React.ComponentPropsWithoutRef<"input">,
  "type"
>;

const selectionClasses =
  "border-input bg-background text-primary focus-visible:ring-ring size-4 shrink-0 cursor-pointer border shadow-sm accent-[var(--primary)] focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 forced-colors:auto";

const Checkbox = React.forwardRef<HTMLInputElement, NativeSelectionProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="checkbox"
      className={cn(selectionClasses, "rounded-sm", className)}
      {...props}
    />
  ),
);
Checkbox.displayName = "Checkbox";

const Radio = React.forwardRef<HTMLInputElement, NativeSelectionProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="radio"
      className={cn(selectionClasses, "rounded-full", className)}
      {...props}
    />
  ),
);
Radio.displayName = "Radio";

export { Checkbox, Radio };
